import { useAppSelector } from 'src/hooks';
import { selectProgram } from 'src/redux/program/selectors';
import { isAndroid } from 'src/utils/is-android';

export function useAndroidDetection() {
  const program = useAppSelector(selectProgram);
  const registrationType = program?.registration?.type;
  const isAndroidDetected = isAndroid();
  const match = navigator.userAgent.match(/android\s([0-9\.]*)/i);
  const version = match ? parseFloat(match[1]) : null;

  const isUIAffected =
    isAndroidDetected &&
    version &&
    version >= 15 &&
    (registrationType === 'Native' || registrationType === 'FormAndNative');

  return {
    isAndroid: isAndroidDetected,
    isUIAffected: Boolean(isUIAffected),
    version,
  };
}
